module.exports = __webpack_public_path__ + "img/braip-white.84e504d2.svg";